import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Input, Form, Select } from 'components/shared/FormComponent';
import { Empty, message, Spin, Table, Tooltip } from 'components/shared/AntComponent';
import SearchIcon from 'assets/img/search.svg';
import { CopyOutlined, DeleteFilled } from 'components/shared/AntIcons';
import { Button } from 'components/shared/ButtonComponent';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import JoditEditor from 'jodit-react';
import { addTemplateManager, getTemplateDetail, getTemplates, getTemplateCat } from 'services/actions/templateManagerAction';
import axios from 'axios';

const { TextArea } = Input;

const AddTemplate = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { loading1, success1, error1, loading3, tempDetailInfo, getTemplateCatInfo, getTemplateCatLoading } = useSelector((state: any) => state.template);
    const [form] = Form.useForm();
    const editor: any = useRef(null);
    const [content, setContent] = useState('');
    const [tags, setTags]: any = useState([]);
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success1 : false;
    const [showErrormsg, setShowErrormsg] = useState(false);
    const errormsg = showErrormsg ? error1 : false;
    const selectedCategory = Form.useWatch('templateCategory', form);

    const handleBack = () => {
        navigate('/template-manager');
    }

    const config = useMemo(() => ({
        readonly: false,
        width: "100%",
        style: { overflowX: "hidden", wordBreak: "break-word" },
    }), []);
    const categoryTagMap = {
        1: ["@invoice_number", "@billing_date", "@billing_due", "@billing_period", "@account_name", "@account_number"], // Invoice processed
        2: ["@invoice_number", "@billing_date", "@billing_due", "@billing_period", "@account_name", "@account_number"],
        3: ["@invoice_number", "@billing_date", "@billing_due", "@billing_period", "@account_name", "@account_number"],
        4: ["@request_number", "@patient_number", "@patient_fname", "@patient_lname", "@account_name", "@account_number"],
        5: ["@request_number", "@patient_number", "@patient_fname", "@patient_lname", "@account_name", "@account_number"],
        6: ["@email_address", "@username"],
        7: ["@email_address", "@otp", "@username"],
        8: ["@invoice_number", "@billing_date", "@billing_due", "@billing_period", "@account_number", "@account_name"],
        9: ["@email_address", "@username"],
        10: ["@invoice_number", "@billing_date", "@billing_due", "@billing_period", "@account_number", "@account_name"],
        11: ["@invoice_number", "@billing_date", "@billing_due", "@billing_period", "@account_number", "@account_name"],
        12: ["@account_name", "@account_email_address", "@account_number"],
        13: ["@patient_fname", "@patient_lname", "@patient_number", "@patient_email"]
    };
    const metaTags = [
        { label: "Email Address", value: "@email_address" },
        { label: "Account Number", value: "@account_number" },
        { label: "Account Name", value: "@account_name" },
        { label: "Invoice Number", value: "@invoice_number" },
        { label: "Job Number", value: "@job_number" },
        { label: "Request Number", value: "@request_number" },
        { label: "Patient Number", value: "@patient_number" },
        { label: "Patient's First Name", value: "@patient_fname" },
        { label: "Patient's Last Name", value: "@patient_lname" },
        { label: "OTP", value: "@otp" },
        { label: "Username", value: "@user_name" },
        { label: "Billing Period", value: "@billing_period" },
        { label: "Billing Date", value: "@billing_date" },
        { label: "Billing Due", value: "@billing_due" },
        { label: "Patient Email", value: "@patient_email" }
    ];

    // const categoryOptions = [{
    //     label: "Invoice",
    //     title: "invoice",
    //     options: [
    //         { value: 1, label: "Invoice processed" },
    //         { value: 2, label: "Invoice due" },
    //         { value: 3, label: "Invoice reminder" },
    //         { value: 10, label: "Invoice generation" },
    //         { value: 8, label: "Credit card expires" },
    //         { value: 11, label: "Payment success" },
    //     ]
    // }, {
    //     label: "Request",
    //     title: "request",
    //     options: [
    //         { value: 4, label: "New request" },
    //         { value: 5, label: "Request released" },
    //     ]
    // },
    // {
    //     label: "Account",
    //     title: "account",
    //     options: [
    //         { value: 12, label: "New account request" },
    //     ]
    // },
    // {
    //     label: "Patient",
    //     title: "patient",
    //     options: [
    //         { value: 13, label: "Patient consent form" },
    //     ]
    // },
    // {
    //     label: "Other",
    //     title: "other",
    //     options: [
    //         { value: 6, label: "Password expired" },
    //         { value: 7, label: "OTP" },
    //         { value: 9, label: "Forgot password" },
    //     ]
    // },

    // ];

    const categoryOptions = getTemplateCatInfo?.data?.reduce((acc: any, item: any) => {
     const type = item.field_type;

     let group = acc.find((g: any) => g.title === type);

     if (!group) {
        group = {
            label: type.charAt(0).toUpperCase() + type.slice(1),
            title: type,
            options: []
        };
        acc.push(group);
     }

     group.options.push({
        value: item.id,
        label: item.field_name
     });

     return acc;
    }, []) || [];

    const handleDragStart = (e, value) => {
        e.dataTransfer.setData("text/plain", value);
        setTags((prevTags: any) => [...prevTags, value]);
    };
    const handleDrop = (e) => {
        e.preventDefault();

        const value = e.dataTransfer.getData("text/plain");

        if (editor.current) {
            editor?.current?.selection?.insertHTML(value);
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault(); // REQUIRED to allow drop
    };

    const statusOptions = [
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" }
    ];

    const saveTemplate = (values: any) => {
        const base64Content = btoa(unescape(encodeURIComponent(content)));
        // setContent(base64Content);
        const inputJson = {
            "accountid": 0,
            "template_id": location?.state?.rowData?.id || 0,
            "name": values?.templateName || "",
            "category_id": values?.templateCategory || null,
            "description": values?.description || "",
            "design": "",
            "subject": values?.subject || "",
            "template_data": base64Content || "",
            "tags": tags || [],
            "comments": "",
            "is_active":true
            // "is_active": values?.templateStatus?.toLowerCase()=="active" ? true : false
        }
        dispatch(addTemplateManager(inputJson) as any);
        setShowErrormsg(true);
        setShowSuccessmsg(true);
        // const decoded = decodeURIComponent(escape(atob(base64Content)));
    }

    useEffect(() => {
        if (successmsg) {
            message.success('Template saved successfully');
            setShowSuccessmsg(false);
            form.resetFields();
            setContent('');
            navigate('/template-manager');

        }
        if (errormsg) {
            if (error1?.data) {
                message.error(error1?.data);
            } else {
                message.error("Template couldn't be saved");
            }
            setShowErrormsg(false);
        }
    }, [errormsg, successmsg]);

    const getHtmlFile = async (templateFile: any) => {
        const res = await axios.get(templateFile);
        const htmlContent = res.data;
        setContent(htmlContent);
    };
    useEffect(() => {
        if (location?.state?.rowData) {
            const rowData = location?.state?.rowData;
            form.setFieldsValue({
                templateName: rowData?.name,
                description: rowData?.description,
                templateCategory: rowData?.category_id,
                subject: rowData?.subject,
                templateStatus: rowData?.is_active ? 'active' : 'inactive'
            });
            if (rowData?.templatefile) {
                getHtmlFile(rowData?.templatefile);
            }

        } else {
            form.resetFields();
            setContent('');

        }
    }, [location?.state]);

    const getTemplateInfo = (id: any) => {
        const inputJson = {
            "accountid": 0,
            "template_id": Number(id)
        }
        dispatch(getTemplateDetail(inputJson) as any);
    }

    // useEffect(() => {
    //     if (location?.state?.rowData) {
    //         getTemplateInfo(location.state?.rowData?.id);
    //     } else {
    //         form.resetFields();
    //         setContent('');
    //     }

    // }, [location?.state?.rowData]);
    const filteredMetaTags = useMemo(() => {
        if (!selectedCategory) return [];

        const allowedTags = categoryTagMap[selectedCategory] || [];

        return metaTags.filter(tag => allowedTags.includes(tag.value));
    }, [selectedCategory]);
    const handleCategoryChange = (value) => {
        form.setFieldsValue({ subject: undefined });
    };
    const handleCopy = (tag: any) => {
        navigator.clipboard.writeText(tag?.value)
            .then(() => {
                message.success(`${tag.label} copied to clipboard`);
            })
            .catch(() => {
                message.error('Failed to copy');
            });
    };
    useEffect(() => {
                dispatch(getTemplateCat(0) as any);
    }, []);
    return (
        <div className="p-3">
            <div className="d-flex grid-title-card">
                <h5 className="my-auto ">{location.state?.rowData ? "Update " : "Add "}Template</h5>
                <div className="ms-auto d-flex title-btn">
                    <Button type="primary" onClick={handleBack} className="add-btn">
                        Back
                    </Button>
                </div>
            </div>
            <div className="my-2 bg-white p-3 template-manager">
                {/* <Spin spinning={loading3}> */}
                <Form layout="vertical" form={form} onFinish={saveTemplate}>
                    <div className="row m-0">
                        <Form.Item name="templateName" label="Template Name" className='col' rules={[{ required: true, message: 'This field is required!' }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item name="templateCategory" className='col-md-2' label="Template Category" rules={[{ required: true, message: 'This field is required!' }]}>
                            <Select className='w-100' options={categoryOptions} onChange={(e) => handleCategoryChange(e)} />
                        </Form.Item>
                        <Form.Item name="subject" label="Subject" className='col' rules={[{ required: true, message: 'This field is required!' }]}>
                            <Input disabled={!selectedCategory} />
                        </Form.Item>
                        {/* <Form.Item name="templateStatus" className='col-md-2' label="Status" rules={[{ required: true, message: 'This field is required!' }]}>
                            <Select className='w-100' options={statusOptions} />
                        </Form.Item> */}
                    </div>
                    <div className='row mx-0'>
                        <Form.Item name="description" label="Description">
                            <TextArea rows={5} />
                        </Form.Item>
                    </div>
                    <div className="row mx-0">
                        <div className="col pt-2 mt-1">
                            <h6 className='fw-normal'>Template Design</h6>
                            <div
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                            >
                                <JoditEditor ref={editor} config={config} value={content}
                                    onBlur={(newContent) => setContent(newContent)}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className='d-flex mb-2 mt-2'>
                                <h6 className='fw-normal col my-auto'>Meta Tags</h6>
                                {/* <div className='col-auto ms-auto '>
                                    <Button type="primary" onClick={handleBack} className="exp-btn fw-bold">
                                        Select Data Source
                                    </Button>
                                </div> */}
                            </div>
                            <div className='border rounded p-3 meta-tag-container'>
                                {filteredMetaTags.map(tag => (
                                    <div
                                        key={tag.value}
                                        draggable
                                        onDragStart={(e) => handleDragStart(e, tag.value)}
                                        className="p-2 border rounded mb-2 bg-lightblue d-flex"
                                        style={{ cursor: "grab" }}
                                    >
                                        {tag.label} <div className='ms-auto' onClick={() => handleCopy(tag)}><CopyOutlined /></div>
                                    </div>
                                ))}
                                {!selectedCategory && (
                                    <p className="text-muted p-5 text-center">Select a category to view meta tags</p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className='d-flex align-items-center my-2 justify-content-end'>
                        <Button className='add-btn' htmlType='submit' type='primary' loading={loading1}>Save</Button>
                    </div>
                </Form>
                {/* </Spin> */}
            </div>
        </div>
    )
}

export default AddTemplate;